module.exports = __webpack_public_path__ + "static/media/check.27ed76f4.svg";